/*
 * @FilePath: /kitchen-offline-web/src/3DEngine/render/room/window.ts
 * @Author: Yongchao Wang
 * @Date: 2021-12-17 10:44:23
 * @LastEditors: Yongchao Wang
 * @LastEditTime: 2021-12-27 15:49:12
 * @Description:
 */
import { MeshBuilder, PBRMetallicRoughnessMaterial, Texture, Vector3, } from '@babylonjs/core';
export default class WindowNode {
    constructor(scene, template) {
        this.scene = scene;
        this.template = template;
    }
    createWindow(windowNode, rotation) {
        const plane = MeshBuilder.CreatePlane(windowNode.name, { height: windowNode.height, width: windowNode.width });
        plane.position = new Vector3(windowNode.position.x, windowNode.position.y, windowNode.position.z);
        plane.addRotation(rotation.x, rotation.y, rotation.z);
        const material = new PBRMetallicRoughnessMaterial(windowNode.name, this.scene);
        material.metallic = 0;
        material.roughness = 0.8;
        const windowTexture = new Texture(windowNode.textureImage, this.scene);
        material.baseTexture = windowTexture;
        plane.material = material;
        this.rotation = rotation;
        this.position = windowNode.position;
        this.windowMesh = plane;
    }
    show(show) {
        if (this.windowMesh) {
            this.windowMesh.isVisible = show;
        }
    }
}
